/**
 * When **true** -- enables "remote controlled LiveChatInc widget". Meaning 3rd party LiveChatInc widget will be totally controlled via LiveChatInc web console;
 *
 * When **false** -- disables "remote controlled LiveChatInc widget". Implementation will use internal solution based on "@livechat/widget-react" module;
 *
 * **Note!** This flag also toggles ScrollToTop button.
 * Lookup for decision information in ticket LTCONT-11835.
 *
 * @name ENABLE_THIRD_PARTY_LIVE_CHAT_WIDGET
 * @source https://github.com/livechat/chat-widget-adapters
 * @source https://platform.text.com/docs/extending-chat-widget/chat-widget-adapters/react-adapter
 * @see useRegisterLiveChatAction
 * @see LiveChatWidget
 * @see useRegisterScrollToTopAction
 * */
export const ENABLE_THIRD_PARTY_LIVE_CHAT_WIDGET = true;
